import React from "react"

import {
	Box,
	Grid,
	IconButton,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material"

import { Trans } from "@lingui/macro"

import Icon from "@mdi/react"
import {
	mdiAccountOutline,
	mdiCheckboxBlankOutline,
	mdiCheckboxOutline,
	mdiContentDuplicate,
	mdiPlusCircle,
	mdiTrashCanOutline,
} from "@mdi/js"

import {
	WorkflowUtils,
	Template,
} from "models"

interface TemplateCardProps
{
	data: Template
	openDeleteDialog: (template: Template) => void
	openAssignDialog: (template: Template) => void
	setDefault: (template: Template) => void
	cloneWorkflowTemplate: (template: Template) => void
	createWorkflowFromTemplate: (template: Template) => void
}
interface TemplateCardState
{
}
export class TemplateCard extends React.Component<TemplateCardProps, TemplateCardState>
{
    private assignButton = () => {
        this.props.openAssignDialog(this.props.data)
    }

    private deleteButton = () => {
        this.props.openDeleteDialog(this.props.data)
    }

    private copyButton = () => {
        this.props.cloneWorkflowTemplate(this.props.data)
    }

    private addButton = () => {
		this.props.createWorkflowFromTemplate(this.props.data)
    }

    private setDefaultButton = () => {
        this.props.setDefault(this.props.data)
    }

    render()
    {
		const data: Template = this.props.data

        return(
			<Grid container spacing={2} alignItems="center" p={0.5}>
				<Grid item xs="auto">
					<Box
						component={Icon}
						path={WorkflowUtils.renderIcon(data.objectType)}
						size="35px"
						sx={{
							color: "primary.contrastText",
							backgroundColor: "primary.main",
							padding: "5px",
							mt: 2,
							borderRadius: "100%",
						}}>
					</Box>
                </Grid>
				<Grid item xs>
					<Stack direction="column">
						<Typography sx={{ fontSize: 20, fontWeight: "medium" }} color="primary">
							{data.name}
						</Typography>
						{data.defaultExecutor &&
							<Typography sx={{ fontSize: 10, fontWeight: '600' }}>
								<Trans id={"workflow.assignedTo"}>
									Assegnato a &nbsp;
									{(data.defaultExecutor.accountDetails && data.defaultExecutor.accountDetails.firstName && data.defaultExecutor.accountDetails.lastName) ?
										<span>{data.defaultExecutor.accountDetails.firstName} {data.defaultExecutor.accountDetails.lastName}</span> :
										<span>{data.defaultExecutor.username}</span>
									}
								</Trans>
							</Typography>
						}
						<Typography sx={{ fontSize: 8 }}>
							{data.description}
						</Typography>
					</Stack>
				</Grid>
				<Grid item xs="auto">
					<Stack direction="row" spacing={1.5} sx={{ display: "block", }}>
                        <Tooltip title="Assegna" placement="top" arrow>
                            <IconButton
								sx={{
									p: 0,
									color: "grey",
									backgroundColor: "transparent",
									":hover": {
										color: "secondary.main",
									},
								}}
                                aria-label="assign"
                                onClick={this.assignButton}
                                disableFocusRipple
                                disableRipple>
                                <Icon path={mdiAccountOutline} size={1} />
                            </IconButton>
                        </Tooltip>
                        {!data.system &&
                            <>
                                <Tooltip title="Elimina" placement="top" arrow>
                                    <IconButton
										sx={{
											p: 0,
											color: "grey",
											backgroundColor: "transparent",
											":hover": {
												color: "secondary.main",
											},
										}}
                                        aria-label="delete"
                                        onClick={this.deleteButton}
                                        disableFocusRipple
                                        disableRipple>
                                        <Icon path={mdiTrashCanOutline} size={1} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Copia" placement="top" arrow>
                                    <IconButton
										sx={{
											p: 0,
											color: "grey",
											backgroundColor: "transparent",
											":hover": {
												color: "secondary.main",
											},
										}}
                                        aria-label="copy"
                                        onClick={this.copyButton}
                                        disableFocusRipple
                                        disableRipple>
                                        <Icon path={mdiContentDuplicate} size={1}/>
                                    </IconButton>
                                </Tooltip>
                            </>
                        }
                        {(!this.props.data.defaultWorkflow && !data.system) &&
                            <Tooltip title="Imposta default" placement="top" arrow>
                                <IconButton
									sx={{
										p: 0,
										color: "grey",
										backgroundColor: "transparent",
										":hover": {
											color: "secondary.main",
										},
									}}
                                    aria-label="add"
                                    onClick={this.setDefaultButton}
                                    disableFocusRipple
                                    disableRipple>
                                    <Icon path={mdiCheckboxBlankOutline} size={1} />
                                </IconButton>
                            </Tooltip>
                        }
                        {(this.props.data.defaultWorkflow && !data.system) &&
                            <Tooltip title="Default" placement="top" arrow>
                                <IconButton
									sx={{
										p: 0,
										color: "secondary.main",
										backgroundColor: "transparent",
										":hover": {
											color: "secondary.main",
										},
									}}
                                    aria-label="add"
                                    disableFocusRipple
                                    disableRipple>
                                    <Icon path={mdiCheckboxOutline} size={1} />
                                </IconButton>
                            </Tooltip>
                        }
						{this.props.data.objectType === "GENERIC" &&
							<Tooltip title="Crea da template" placement="top" arrow>
								<IconButton
									sx={{
										p: 0,
										color: "primary.main",
										backgroundColor: "transparent",
										":hover": {
											color: "secondary.main",
										},
									}}
									aria-label="add"
									onClick={this.addButton}
									disableFocusRipple
									disableRipple>
									<Icon path={mdiPlusCircle} size={1} />
								</IconButton>
							</Tooltip>
						}
                    </Stack>
                </Grid>
            </Grid>
        )
    }
}
